var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160.003,
    viewBox: "0 0 160 160.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Icon",
    "data-name": "Logo Icon",
    transform: "translate(-343.662 -475.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M423.662,475.351c-63,0-80,17-80,80s17,80,80,80,80-17,80-80S486.662,475.351,423.662,475.351Zm47.453,53.912-9.793,36.622a1.465,1.465,0,0,1-1.8,1.041l-11.659-3.118a1.465,1.465,0,0,1-1.037-1.8l2.639-9.863a1.474,1.474,0,0,0-2.159-1.655l-16.126,9.331.018,18.638a1.47,1.47,0,0,0,2.508,1.04l7.221-7.232a1.467,1.467,0,0,1,2.078,0l8.534,8.527a1.463,1.463,0,0,1,0,2.074l-26.787,26.822a1.463,1.463,0,0,1-2.075,0l-26.818-26.786a1.473,1.473,0,0,1,0-2.078l8.523-8.538a1.466,1.466,0,0,1,2.078,0l7.229,7.215a1.467,1.467,0,0,0,2.5-1.04l-.014-18.631-16.147-9.306a1.468,1.468,0,0,0-2.152,1.651l2.653,9.871a1.474,1.474,0,0,1-1.037,1.8l-11.652,3.129a1.472,1.472,0,0,1-1.8-1.037l-9.832-36.611a1.467,1.467,0,0,1,1.037-1.8l36.612-9.835a1.468,1.468,0,0,1,1.8,1.04l3.129,11.653a1.471,1.471,0,0,1-1.037,1.8l-9.864,2.649a1.468,1.468,0,0,0-.349,2.688l16.143,9.3,16.126-9.331a1.466,1.466,0,0,0-.356-2.688l-9.867-2.643a1.464,1.464,0,0,1-1.044-1.8l3.115-11.656a1.475,1.475,0,0,1,1.8-1.044l36.619,9.793A1.47,1.47,0,0,1,471.115,529.263Z",
    transform: "translate(0 0)",
    fill: "#009edb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7c254e0d62c7b7495cd66e5de0b33a91.svg";
export { ForwardRef as ReactComponent };